import React from "react";
import RangeSlider from "./RangeSlider";

export default function SalaryRange({ salaryRange, setSalaryRange,NoPrefSalary, setNoPrefSalary}) {
  return <div>

    <RangeSlider
        label="Salary Range"
        unit="Lpa"
        min={3}
        max={100}
        step={0.1}
        values={salaryRange}
        setValues={setSalaryRange}
        leftLabel=""
        rightLabel=""
        colorClass="primary"
        noPref={NoPrefSalary}
        setNoPref={setNoPrefSalary}
      />
  </div>;
}
